
export const useStyles = () => {
    return {
        container: {
            padding: 3
        },
        containerItem: {
            padding: 2
        },
        add: {
            fontSize: '2rem',
            color: 'secondary.100'
        },
        avatar: {
            //width: '25px',
            backgroundColor: 'blue.main',
            width: 'auto',
            padding: '0px 8px',
            height: '25px',
            fontSize: '12px',
            borderRadius: '40px'
        },
        rightActions: {
            display: 'flex',
            alignItems: 'center',
            gap: 1
        },
        alignHorizontal: {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
        },
        root: {
            display: 'flex',
            flexDirection: 'column'
        },
        arrow: {
            padding: 0,
            '& .MuiSvgIcon-root': {
                fontSize: '2rem',
            }
        },
        rotate: (expand: boolean | undefined) => ({
            transition: '200ms',
            transform: `rotate(${expand ? '180deg' : '0deg'})`,
            '& .MuiSvgIcon-root': {
                fontSize: '2rem',
            }
        }),
        list: {
            width: '100%',
            height: '350px',
        },
    }
}